import { PopularProgramCardContentFooter } from '@components/buzzkuri/pages/ProgramsSlugs/ProgramCategory/PopularProgram/CardGroup/Card/Content/Footer'
import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { WindowSizeContext } from '@context/WindowSize/Context'
import { ProgramThumbnailGroupItem } from '@type/buzzkuri/program-detail'
import Link from 'next/link'
import React from 'react'
import { useContext } from 'react'

type Props = ProgramThumbnailGroupItem

const capacity = 50
const requiredTime = 90

export const RecommendTrainingProgramListItem = ({
  id,
  imagePath,
  name,
}: Props): JSX.Element => {
  const winSize = useContext(WindowSizeContext)

  return (
    <Link href={`/programs/${id}`}>
      <a>
        <div className="flex flex-col lg:w-[21.9vw] lg:hover:opacity-50">
          <div>
            <ImageWraper
              src={imagePath}
              width={280}
              height={138}
              alt={`${name}のイメージ画像`}
            />
          </div>
          <div className="mt-[5.3vw] lg:mt-[1.3vw] text-[3.7vw] lg:text-[0.9vw] font-bold text-[#333333]">
            {name}
          </div>
          {winSize?.screenTarget === 'sp' && (
            <div className="mt-[4vw]">
              <PopularProgramCardContentFooter
                {...{ capacity, requiredTime }}
              />
            </div>
          )}
        </div>
      </a>
    </Link>
  )
}
